var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-box"},[_c('div',{staticClass:"flex justify-center",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"thumb",style:({
        'border-radius': _vm.border + 'px',
        'background-image': 'url(' + _vm.value + ')',
        width: '100%',
        height: _vm.height + 'px',
        'background-position': 'center center',
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
      })})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-014cbb12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/thumb-bar.vue
// module id = null
// module chunks = 